import {inject, Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {FeedbackService} from 'frontier';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  _feedbackService = inject(FeedbackService);

  downloadJsonFromBlobResponse(res: HttpResponse<any>) {
    const fileContent: Blob = res?.body;
    let fileName: string = res.headers.get('content-disposition')?.split('filename=')[1]?.split(';')[0];
    if (fileName) {
      fileName = fileName.substring(1, fileName.length - 1);
    }
    if (fileContent == null) {
      this._feedbackService.setError('Es konnte keine JSON-Datei heruntergeladen werden.');
      return;
    }
    const url: string = URL.createObjectURL(fileContent);
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = url;
    a.download = fileName || 'export.json';
    a.click();
    URL.revokeObjectURL(url);
  }

  downloadFromBlobResponseWithFileName(res: Blob, fileName: string) {
    const fileContent: Blob = res;

    if (fileContent == null) {
      this._feedbackService.setError('Es konnte keine JSON-Datei heruntergeladen werden.');
      return;
    }
    const url: string = URL.createObjectURL(fileContent);
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  downloadObjectAsJson(exportObj: object, exportName: string) {
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  getFileContentFromUploadEvent(evt: Event): Observable<string | ArrayBuffer | null> {
    const input = evt.target as HTMLInputElement;
    const file: File = (evt.target as any).files[0];

    if (file) {
      const reader: FileReader = new FileReader();

      return new Observable<string | ArrayBuffer>((observer) => {
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const data: string | ArrayBuffer = e.target?.result;
          observer.next(data);
          observer.complete();
        };
        reader.onerror = (error) => {
          observer.error(error);
        };
        reader.readAsText(file);

        // reset value so that change detection can trigger again on the same file if needed
        input.value = '';
      });
    }
    return of(null);
  }
}
